var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("../assets/loading.gif"),"alt":"TW Icon Game"}}),_c('h2',{staticClass:"md-display-6"},[_vm._v("Pokemon Master")]),_c('select-game-type'),_c('select-language')],1)}
var staticRenderFns = []

export { render, staticRenderFns }